import { UNSCORED_UNSUBSCRIBE_ERROR_TEXT } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { colors, spacing } from 'ui/theme';
import { TextButton } from 'ui/button';
import { FC } from 'react';
import { pxToRem } from 'utils/convert';

const Wrapper = styled.div`
  width: ${pxToRem(560)};
`;
const DescriptionWrapper = styled.span`
  color: ${colors.textSecondary};
`;
const StyledTextButton = styled(TextButton)`
  padding: 0 ${spacing.quarter};
`;

export const UnscoredUnsubsubcribeMetricsErrorId = 'unscored-unsubscribe-error';
export interface UnscoredUnsubscribeErrorProps {
  onRefresh?: () => void;
}
export const UnscoredUnsubsubcribeMetricsError: FC<UnscoredUnsubscribeErrorProps> = ({
  onRefresh,
}) => (
  <Wrapper data-error="true" data-test={UnscoredUnsubsubcribeMetricsErrorId}>
    <EmptyState
      Illustration={() => <ErrorStatePageError width={spacing.x7} />}
      title="We’ve hit a snag"
      data-test="unscored-unsubscribe-error-state"
      subtitle={
        <DescriptionWrapper>
          {UNSCORED_UNSUBSCRIBE_ERROR_TEXT}
          <StyledTextButton
            onClick={() => {
              onRefresh?.();
            }}
          >
            try refreshing the page.
          </StyledTextButton>
        </DescriptionWrapper>
      }
    />
  </Wrapper>
);
